<style></style>
<template>
  <div class="container">
    <v-overlay :value="cargando" absolute z-index="1060">
        <v-progress-circular indeterminate size="70" :width="3"> </v-progress-circular>
      </v-overlay>
    <div>
      <!-- <div id="loader-wrapper" v-if="cargando">
        <div id="loader"></div>
      </div> -->
      <div class="row">
        <div class="form-group col-md-12">
          <div class="card card-wizard" id="wizardCard">
            <div class="row pl-3 pr-3">
              <div class="col">
                <legend>Importar padrón de bajas</legend>
              </div>
              <div class="col text-right">
                <br>
                <v-btn outlined color="primary" :href="'https:' + $rootUrl + '/PlantillaBajas.xlsx'" target="_blanc">
                  <i class="fa fa-file-excel mr-3"></i>
                  Descargar Plantilla
                </v-btn>
              </div>
            </div>
            <form action="" @submit.prevent="saveComprobante">
              <v-container class="border-top p-4">
                <v-row class="d-flex align-items-center justify-content-between" v-if="ente_publico_id || getKey('permisos').includes(28)">
                  <div class="p-3">
                    Seleccionar el archivo excel
                  </div>
                  <div class="flex-grow-1">
                    <input id="xlsx" ref="xlsx" accept=".xlsx" @change="addFile('xlsx')" required class="form-control" type="file">
                  </div>
                  <div class="p-3">
                    <v-btn outlined color="blue-grey darken-1" :loading="cargando" @click="saveComprobante()">
                      Cargar
                    </v-btn>
                  </div>
                </v-row>
              </v-container>
            </form>
          </div>
          <div class="card card-wizard" id="wizardCardOk" v-if="Object.entries(correctos).length > 0">
            <h5 class="bg-success rounded-top text-white p-3" align="center">
              Los registros se han importado con éxito, tiempo de carga: {{ tiempo }}
            </h5>
            <v-data-table
                          :headers="headers_correctos"
                          :items="correctos"
                          :items-per-page="5"
                          dense></v-data-table>
          </div>
          <div class="card card-wizard" id="wizardCardOk" v-if="Object.entries(anticipadas).length > 0">
            <h5 class="bg-info rounded-top text-white p-3" align="center">
              Los siguientes registros se programarán para su baja posterior, tiempo de carga: {{ tiempo }}
            </h5>
            <v-data-table
                          :headers="headers_correctos"
                          :items="anticipadas"
                          :items-per-page="5"
                          dense></v-data-table>
          </div>
          <div class="card card-wizard" id="wizardCardIn" v-if="Object.entries(incorrectos).length > 0">
            <h5 class="bg-danger rounded-top text-white p-3" align="center">
              Los siguientes registros cuentan con errores, favor de corregirlos y volver a cargar la plantilla. No se ha cargado ningún registro.
            </h5>
            <v-data-table
                          :headers="headers_incorrectos"
                          :items="incorrectos"
                          :items-per-page="5"
                          dense></v-data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  FormWizard,
  TabContent
} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import swal from 'sweetalert2'
export default {
  data () {
    return {
      search: '',
      rol: null,
      color: true,
      loading: true,
      cargando: true,
      tiempo: '',
      options: {},
      wizardModel: {},
      incorrectos: [],
      anticipadas: [],
      correctos: 0,
      grupo: 2,
      xlsx: 0,
      simplificadafl: false,
      // entes: null,
      ente_publico_id: null,
      simplificada: '0',
      headers_incorrectos: [
        { text: 'Renglon', value: 'Renglon', align: 'start', sortable: false },
        { text: 'Columna(s)', value: 'Columna', align: 'start', sortable: false },
        { text: 'RFC', value: 'RFC', align: 'start', sortable: false },
        { text: 'Mensaje', value: 'Mensaje', align: 'start', sortable: false }
      ],
      headers_correctos: [
        { text: 'RFC', value: 'rfc', align: 'start', sortable: false },
        { text: 'CURP', value: 'curp', align: 'start', sortable: false },
        { text: 'Fecha baja', value: 'fecha_baja', align: 'start', sortable: false },
        { text: 'Tipo de baja', value: 'tipo_baja', align: 'start', sortable: false }
      ],
      fields_list: [{
        key: 'Renglon',
        label: 'Renglon',
        tdClass: 'text-left'
      },
      {
        key: 'Columna',
        label: 'Columna(s)',
        tdClass: 'text-left'
      },
      {
        key: 'Nombre',
        label: 'Nombre',
        tdClass: 'text-left'
      },
      {
        key: 'RFC',
        label: 'RFC',
        tdClass: 'text-left'
      },
      {
        key: 'Mensaje',
        label: 'Mensaje',
        tdClass: 'text-left',
        formatter: 'emptyFields'
      }
      ],
      totalItems: 0,
      listSize: {
        itemsPerPageOptions: [10, 25, 50, 100],
        showFirstLastPage: true
      },
      pagination: {
        page: 1,
        itemsPerPage: 10
      },
      headers: [{
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      },
      {
        text: 'Dependencia',
        value: 'dependencia',
        align: 'left'
      }
      ]
    }
  },
  components: {
    FormWizard
  },
  watch: {
    search (val) {
      if (val.length >= 4 || val.length == 0) { this.getSinIngresos() }
    },
    '$route': 'checkPermissions',
    'grupo': function (val) {
      if (val == 3) {
        this.simplificada = '1'
        this.simplificadafl = true
      } else { this.simplificadafl = false }
    },
    'simplificada': function (val) {
      if (val == '1') { this.grupo = 3 } else { this.grupo = 2 }
    }
  },
  methods: {
    uppercase () {
      this.search = this.search.toUpperCase()
    },
    checkPermissions () {
      let permiso = [28]
      if (!this.getKey('permisos').some(r => permiso.includes(r))) {
        localStorage.clear()
        this.$router.push('/login')
        this.$router.go()
      }
    },
    // getBajas (e) {
    //   var sortDesc = false
    //   if (e) {
    //     sortDesc = e.sortDesc[0]
    //     console.log(sortDesc)
    //   }
    //   var params = {
    //     params: {
    //       page: this.pagination.page,
    //       itemsPerPage: this.pagination.itemsPerPage,
    //       search: this.search,
    //       sortDesc: sortDesc
    //     }
    //   }

    //   this.$http.get('sueldos_otros_rfc', params).then(response => {
    //     var lista_ = response.data.lista

    //     this.sinIngresos = [...lista_.data]

    //     this.totalItems = Number(lista_.total)
    //     this.pagination.page = Number(lista_.current_page)
    //     this.pagination.pagelength = Number(lista_.last_page)

    //     this.loading = false
    //   }, error => {
    //     this.loading = false
    //     this.StepError(error)
    //   })
    // },
    saveComprobante () {
      let preg = 'Se darán de baja a los usuarios de la lista cargada, ¿Quieres continuar?'

      /* if(this.simplificada=='1'){
        preg='Éstos registros se agregaran para presentar la declaración simplificada'
      }else{
        preg='Éstos registros se agregaran para presentar la declaración completa en el grupo '+this.grupo
      } */
      this.Ask(preg,
        () => {
          this.color = true
          this.cargando = true
          this.incorrectos = []
          this.correctos = []
          // this.loadButton(this.$refs.btnSave)
          const formData = new FormData()
          formData.append('ente_publico_id', this.ente_publico_id)
          formData.append('xlsx', this.xlsx)

          this.$http.post('ExcelBajas', formData).then(
            response => {
              this.incorrectos = response.data.incorrectos
              this.correctos = response.data.correctos
              this.anticipadas = response.data.anticipadas
              this.tiempo = response.data.tiempo
              if (this.incorrectos.length > 0) {
                this.color = false
              }
              this.cargando = false
              // this.onReady()
              // console.log("Entramos aquí")
            },
            error => {
              this.cargando = false
              this.color = false
              if (((error || {}).data || {}).incorrectos) {
                this.incorrectos = error.data.incorrectos
              } else {
                this.Err(error)
              }
            }
          )
        }
      )
    },
    addFile (tipo) {
      this.xlsx = this.$refs.xlsx.files[0]
    },
    validateFirstStep () {
      return this.$refs.firstStep.validate()
    },
    validateSecondStep () {
      return this.$refs.secondStep.validate()
    },

    wizardComplete () {
      // we gather models from all steps into one model
      this.wizardModel = {
        ...this.$refs.datosPersonales.model,
        ...this.$refs.firstStep.model,
        ...this.$refs.DatosCurriculares.model,
        ...this.$refs.DatosConyuge.model,
        ...this.$refs.secondStep.model
      }
      this.$swal('Good job!', 'You clicked the finish button!', 'success')
    }
  },
  created () {
    this.checkPermissions()
    this.rol = this.getKey('grupo')

    // this.$http.get('cat_ente_publico').then(
    //   response => {
    //     this.entes = response.data.entes_publicos
    //   },
    //   error => {
    //     this.Err(error)
    //   }
    // )
    //  console.log('a');
    this.cargando = false
  }
}

</script>
<style>
.vue-form-wizard .wizard-icon-circle.tab_shape {
  background-color: #9a9a9a !important;
  color: white;
}

.radio label {
  margin-left: 30px !important;
}

.no {
  margin-left: 80px !important;
}

.checkbox,
.radio {
  margin-bottom: 0px !important;
  margin-top: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/PlantillaBajas.vue